module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/how-works-desktop--pt.53da5179.svg";